import { makeVar, useReactiveVar } from '@apollo/client';
import { IconButton, makeStyles, Stack, TooltipHost } from '@fluentui/react';
import { useReactFlow } from '@xyflow/react';
import { getWindowDimensions } from 'common/utils/columnUtilities';
import { useEffect } from 'react';
import { LEVEL_NODE_WIDTH } from '../../../settings/account/intuitiveApprovalSetupFlow/ApprovalFlowDesigner/constants';

export const setInteractive = makeVar<boolean>(true);

export const CustomReactFlowControls = () => {
  const reactFlowInstance = useReactFlow();
  const { zoomIn, zoomOut, fitView, setViewport } = reactFlowInstance;
  const isInteractive = useReactiveVar(setInteractive);
  const { width } = getWindowDimensions();
  const styles = useStyles();
  const toggleLock = () => {
    setInteractive(!isInteractive);
  };

  useEffect(() => {
    setInteractive(true);
  }, []);

  return (
    <Stack className={styles.mainContainer}>
      <TooltipHost content={'Zoom In'}>
        <IconButton
          iconProps={{ iconName: 'ZoomIn' }}
          onClick={() => zoomIn()}
        />
      </TooltipHost>

      <TooltipHost content={'Zoom out'}>
        <IconButton
          iconProps={{ iconName: 'ZoomOut' }}
          onClick={() => zoomOut()}
        />
      </TooltipHost>

      <TooltipHost content={'Fit view'}>
        <IconButton
          iconProps={{ iconName: 'FullView' }}
          onClick={() => fitView({ padding: 0.4 })}
        />
      </TooltipHost>

      <TooltipHost content={'Reset top viewpoint'}>
        <IconButton
          iconProps={{ iconName: 'PicturePosition' }}
          onClick={() => {
            setViewport({
              x: width ? width / 2 - LEVEL_NODE_WIDTH : 0,
              y: 200,
              zoom: 0.6,
            });
          }}
        />
      </TooltipHost>
      <TooltipHost content={''}>
        <IconButton
          iconProps={{ iconName: isInteractive ? 'Unlock' : 'Lock' }}
          onClick={toggleLock}
        />
      </TooltipHost>
    </Stack>
  );
};

export const useStyles = makeStyles((theme) => ({
  mainContainer: {
    position: 'absolute',
    bottom: 30,
    left: 30,
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    padding: 8,
    borderRadius: 8,
    backgroundColor: theme.palette.neutralLighter,
    // boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
    zIndex: 100,
  },
}));
